import { render, staticRenderFns } from "./PsHomeDecreaseInPatientsItems.vue?vue&type=template&id=fd607f6e&scoped=true&"
import script from "./PsHomeDecreaseInPatientsItems.vue?vue&type=script&lang=js&"
export * from "./PsHomeDecreaseInPatientsItems.vue?vue&type=script&lang=js&"
import style0 from "./PsHomeDecreaseInPatientsItems.vue?vue&type=style&index=0&id=fd607f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd607f6e",
  null
  
)

export default component.exports